var _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStackOverflow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.3115 14.1396C17.7254 14.1396 18.0612 14.4758 18.0615 14.8896V21.8608H2.87256V14.8896C2.87283 14.4758 3.20865 14.1396 3.62256 14.1396C4.03632 14.1398 4.37228 14.4759 4.37256 14.8896V20.3623H16.5615V14.8896C16.5618 14.4759 16.8977 14.1398 17.3115 14.1396Z",
    fill: "#FC4C02"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.7637 17.8325C14.1775 17.8326 14.5134 18.1687 14.5137 18.5825C14.5136 18.9965 14.1776 19.3324 13.7637 19.3325H7.06055C6.64663 19.3324 6.31059 18.9965 6.31055 18.5825C6.31082 18.1688 6.64677 17.8327 7.06055 17.8325H13.7637Z",
    fill: "#FC4C02"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.9395 15.4639L14.0874 15.4932C14.4213 15.5944 14.6498 15.9205 14.6162 16.2812C14.5822 16.6416 14.2976 16.9187 13.9512 16.9565H13.7988L7.125 16.331C6.7132 16.292 6.41121 15.927 6.44971 15.5151C6.48861 15.1032 6.85357 14.7998 7.26562 14.8384L13.9395 15.4639Z",
    fill: "#FC4C02"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.96582 11.2656L14.4375 13.0102L14.5796 13.0644C14.8911 13.2208 15.0603 13.5791 14.9663 13.9287C14.872 14.2786 14.5454 14.5039 14.1973 14.4824L14.0479 14.4575L7.57617 12.7143C7.17659 12.6066 6.93999 12.1955 7.04736 11.7959C7.15524 11.3965 7.56626 11.1582 7.96582 11.2656Z",
    fill: "#FC4C02"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.66748 7.61962C8.87757 7.26313 9.33764 7.14324 9.69434 7.35302L15.4702 10.7529L15.5933 10.8437C15.8517 11.0772 15.9187 11.4678 15.7354 11.7798C15.5516 12.0919 15.1775 12.2223 14.8477 12.1094L14.71 12.0464L8.93262 8.64648C8.5761 8.43633 8.45755 7.97633 8.66748 7.61962Z",
    fill: "#FC4C02"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.5449 3.44921C12.8879 3.2178 13.3547 3.30858 13.5864 3.65136L17.3364 9.20605L17.4097 9.34081C17.5423 9.66274 17.4354 10.0449 17.1357 10.2475C16.8354 10.4503 16.44 10.4067 16.1909 10.1626L16.0942 10.0454L12.3442 4.49071C12.1129 4.14767 12.2021 3.6809 12.5449 3.44921Z",
    fill: "#FC4C02"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.625 1.38232C18.033 1.31281 18.4209 1.5882 18.4907 1.99608L19.6172 8.60253L19.6274 8.75487C19.6159 9.10333 19.3605 9.40734 19.0034 9.46825C18.6461 9.52906 18.3048 9.32631 18.1787 9.00097L18.1392 8.85448L17.0127 2.24804C16.9434 1.8401 17.2171 1.45197 17.625 1.38232Z",
    fill: "#FC4C02"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStackOverflow);
export default __webpack_public_path__ + "static/media/StackOverflow.8d78c7fe065ae9ac2b3f872d0aa727b8.svg";
export { ForwardRef as ReactComponent };